// src/firebase.js
// Firebase 초기화. 클라이언트 SDK 만 사용.
// 서버사이드(Cloudflare Functions)에서는 Admin SDK 또는 REST 우회.

import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, OAuthProvider, FacebookAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export const googleProvider = new GoogleAuthProvider();
export const appleProvider = new OAuthProvider('apple.com');

// 지역별 메신저 소셜 로그인.
// Kakao / LINE 은 Firebase 기본 제공자가 아니라 Identity Platform 의 OIDC 제공자로 등록한다.
// (Firebase 콘솔에서 제공자 ID 를 정확히 'oidc.kakao' / 'oidc.line' 로 생성해야 아래와 매칭됨)
export const facebookProvider = new FacebookAuthProvider();
facebookProvider.addScope('email');

export const kakaoProvider = new OAuthProvider('oidc.kakao');
kakaoProvider.addScope('openid');
// account_email 은 카카오 동의항목 활성화(보통 비즈니스 앱 전환) 후에만 요청 가능.
// 설정 안 된 스코프를 요청하면 KOE205 발생 → 지금은 openid 만 요청한다.
// kakaoProvider.addScope('account_email');

export const lineProvider = new OAuthProvider('oidc.line');
lineProvider.addScope('openid');
lineProvider.addScope('email');
lineProvider.addScope('profile');
